export enum MUSIMAP_PROPS {
  MUSIMAP_PREFERENCES_MARKER = 'isMusimapFilters',
  SEARCH_FILTER_SETTINGS = 'searchFilterSettings',
}

export enum MUSIMAP_FILTERS {
  GENRES = 'Genres',
  MOOD = 'Mood',
  CHART_DATES = 'Chart Dates',
  THEME = 'Lyric Theme',
  SCENE = 'Scene',
  VOCALS = 'Vocals',
  LANGUAGE = 'Language',
  VOCAL_MIX = 'Vocal mix',
  KEY = 'Key',
  RHYTHMIC_VIBE = 'Rhythmic Vibe',
  GCDM_VERSION = 'Gcdm Versions',

  VERSION = 'Version',
  RECORD_LABEL = 'Record label',
  RATING = 'Parental Warning Type',
  PROFIT_CENTER = 'Profit Center',
  ASSET_TYPE = 'Asset Type',

  CHART_RANGE = 'Chart Range',
  DANCEABILITY = 'Danceability',
  SONIC_DENSITY = 'Sonic Density',
  BPM = 'BPM',
  DURATION = 'Duration (s)',

  DIVISIONS = 'Divisions',
  PUBLISHING_CONTROL = 'Publishing Control',
  RELEASE_YEAR = 'Release Year',
  COPYRIGHT_YEAR = 'Copyright Year',
  ROC = 'ROC',
  ARTIST = 'Artist',
  TITLE = 'Title',
  LABEL = 'Label',
  WRITER = 'Writer',
  LYRICS = 'Lyrics',
  ALBUM = 'Album',
  ORIGINAL_ALBUM = 'Original Album',
  ISRC = 'ISRC',
}

export enum MUSIMAP_API {
  FILTERS = 'filters',
  EXTENDED_FILTERS = 'filters-extended',
  SAVED_PREFERENCES = 'songs/search/settings/filters',
  USER_DATA = 'users/current_user_info',
}

export enum MUSIMAP_COMPONENTS {
  TAGS_SELECTOR = 'tagsSelector',
  RANGE_SELECTOR = 'rangeSelector',
}

export enum MUSIMAP_WIDGETS {
  SIMPLE_TAGS_SELECTOR = 'SimpleTagsSelector',
  MULTI_LEVEL_TAGS_SELECTOR = 'MultiLevelTagsSelector',
  MULTI_SOURCE_TAGS_SELECTOR = 'MultiSourceTagsSelector',
  OPTIONS_SELECTOR = 'OptionsSelector',
  RANGE_SELECTOR = 'RangeSelector',
  DIVISIONS_SELECTOR = 'DivisionsSelector',
  CHART_SELECTOR = 'ChartSelector',
  CHART_RANGE_SELECTOR = 'ChartRangeSelector',
  TEXT_SELECTOR = 'TextSelector',
  SIMPLE_TEXT_SELECTOR = 'SimpleTextSelector',
}

export enum MUSIMAP_OPERATORS {
  AND = 'AND',
  OR = 'OR',
}

export enum MUSIMAP_DIVISIONS {
  WMG = 'WMG',
  WCM = 'WCM',
  NON_WMG = 'NON_WMG',
  NON_WCM = 'NON_WCM',
  WMG_WCM = 'WMG_WCM',
  WMG_WCM_MLR = 'WMG_WCM_MLR',
  ALL = 'WMG_WCM_MLR_CLA',
  MLR = 'MLR',
  THIRD_PARTY_OWNED = 'THIRD_PARTY_OWNED',
  WMG_MLR = 'WMG_MLR',
  WCM_MLR = 'WCM_MLR',
  WMG_WCM_CLA = 'WMG_WCM_CLA',
  CLA = 'CLA',
  WMG_CLA = 'WMG_CLA',
}

export enum MUSIMAP_SELECTION_STATES {
  NOT_SELECTED = 'notSelected',
  EXCLUDED_ALL = 'excludedAll',
  EXCLUDED_SOME = 'excludedSome',
  MIXED = 'mixed',
  INCLUDED_SOME = 'includedSome',
  INCLUDED_ALL = 'includedAll',
  HAS_PREFERENCE = 'hasPreference',
  IS_CONJUNCTIVE = 'isConjunctive',
}

export enum RATINGS {
  ExplicitContentEdited = 'Explicit Content Edited',
  Explicit = 'Explicit',
  NoAdviceAvailable = 'No Advice Available',
  NotExplicit = 'Not Explicit',
  ParentalAdvisory = 'Parental Advisory',
}
